/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAssetType1 } from './ControlAssetType1';
import {
    ControlAssetType1FromJSON,
    ControlAssetType1FromJSONTyped,
    ControlAssetType1ToJSON,
} from './ControlAssetType1';
import type { ControlCategory8 } from './ControlCategory8';
import {
    ControlCategory8FromJSON,
    ControlCategory8FromJSONTyped,
    ControlCategory8ToJSON,
} from './ControlCategory8';
import type { ControlCategoryClass2 } from './ControlCategoryClass2';
import {
    ControlCategoryClass2FromJSON,
    ControlCategoryClass2FromJSONTyped,
    ControlCategoryClass2ToJSON,
} from './ControlCategoryClass2';
import type { ControlDateFilterDto } from './ControlDateFilterDto';
import {
    ControlDateFilterDtoFromJSON,
    ControlDateFilterDtoFromJSONTyped,
    ControlDateFilterDtoToJSON,
} from './ControlDateFilterDto';
import type { ControlIntegrationPlatform6 } from './ControlIntegrationPlatform6';
import {
    ControlIntegrationPlatform6FromJSON,
    ControlIntegrationPlatform6FromJSONTyped,
    ControlIntegrationPlatform6ToJSON,
} from './ControlIntegrationPlatform6';
import type { ControlOrderDir } from './ControlOrderDir';
import {
    ControlOrderDirFromJSON,
    ControlOrderDirFromJSONTyped,
    ControlOrderDirToJSON,
} from './ControlOrderDir';
import type { ControlSeverity8 } from './ControlSeverity8';
import {
    ControlSeverity8FromJSON,
    ControlSeverity8FromJSONTyped,
    ControlSeverity8ToJSON,
} from './ControlSeverity8';
import type { ControlStatus9 } from './ControlStatus9';
import {
    ControlStatus9FromJSON,
    ControlStatus9FromJSONTyped,
    ControlStatus9ToJSON,
} from './ControlStatus9';
import type { ControlVerdict9 } from './ControlVerdict9';
import {
    ControlVerdict9FromJSON,
    ControlVerdict9FromJSONTyped,
    ControlVerdict9ToJSON,
} from './ControlVerdict9';

/**
 * 
 * @export
 * @interface ControlSearchDetectionsDto
 */
export interface ControlSearchDetectionsDto {
    /**
     * 
     * @type {string}
     * @memberof ControlSearchDetectionsDto
     */
    assetId?: string;
    /**
     * 
     * @type {ControlAssetType1}
     * @memberof ControlSearchDetectionsDto
     */
    assetType?: ControlAssetType1;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchDetectionsDto
     */
    caseIdOrSid?: string;
    /**
     * 
     * @type {ControlCategory8}
     * @memberof ControlSearchDetectionsDto
     */
    category?: ControlCategory8;
    /**
     * 
     * @type {ControlCategoryClass2}
     * @memberof ControlSearchDetectionsDto
     */
    categoryClass?: ControlCategoryClass2;
    /**
     * 
     * @type {ControlDateFilterDto}
     * @memberof ControlSearchDetectionsDto
     */
    createdAt?: ControlDateFilterDto;
    /**
     * 
     * @type {number}
     * @memberof ControlSearchDetectionsDto
     */
    days?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchDetectionsDto
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchDetectionsDto
     */
    exclusionId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchDetectionsDto
     */
    filter?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlSearchDetectionsDto
     */
    groupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlSearchDetectionsDto
     */
    hideDemoClients?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlSearchDetectionsDto
     */
    hideExcluded?: boolean;
    /**
     * 
     * @type {ControlIntegrationPlatform6}
     * @memberof ControlSearchDetectionsDto
     */
    integrationPlatform?: ControlIntegrationPlatform6;
    /**
     * 
     * @type {boolean}
     * @memberof ControlSearchDetectionsDto
     */
    onlyChatOps?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlSearchDetectionsDto
     */
    onlyWasContained?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlSearchDetectionsDto
     */
    onlyWasEscalated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchDetectionsDto
     */
    orderBy?: string;
    /**
     * 
     * @type {ControlOrderDir}
     * @memberof ControlSearchDetectionsDto
     */
    orderDir?: ControlOrderDir;
    /**
     * 
     * @type {number}
     * @memberof ControlSearchDetectionsDto
     */
    page?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchDetectionsDto
     */
    search?: string;
    /**
     * 
     * @type {ControlSeverity8}
     * @memberof ControlSearchDetectionsDto
     */
    severity?: ControlSeverity8;
    /**
     * 
     * @type {number}
     * @memberof ControlSearchDetectionsDto
     */
    size?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchDetectionsDto
     */
    startDate?: string;
    /**
     * 
     * @type {Array<ControlStatus9>}
     * @memberof ControlSearchDetectionsDto
     */
    statuses?: Array<ControlStatus9>;
    /**
     * 
     * @type {ControlVerdict9}
     * @memberof ControlSearchDetectionsDto
     */
    verdict?: ControlVerdict9;
}

/**
 * Check if a given object implements the ControlSearchDetectionsDto interface.
 */
export function instanceOfControlSearchDetectionsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlSearchDetectionsDtoFromJSON(json: any): ControlSearchDetectionsDto {
    return ControlSearchDetectionsDtoFromJSONTyped(json, false);
}

export function ControlSearchDetectionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSearchDetectionsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetId': !exists(json, 'assetId') ? undefined : json['assetId'],
        'assetType': !exists(json, 'assetType') ? undefined : ControlAssetType1FromJSON(json['assetType']),
        'caseIdOrSid': !exists(json, 'caseIdOrSid') ? undefined : json['caseIdOrSid'],
        'category': !exists(json, 'category') ? undefined : ControlCategory8FromJSON(json['category']),
        'categoryClass': !exists(json, 'categoryClass') ? undefined : ControlCategoryClass2FromJSON(json['categoryClass']),
        'createdAt': !exists(json, 'createdAt') ? undefined : ControlDateFilterDtoFromJSON(json['createdAt']),
        'days': !exists(json, 'days') ? undefined : json['days'],
        'endDate': !exists(json, 'endDate') ? undefined : json['endDate'],
        'exclusionId': !exists(json, 'exclusionId') ? undefined : json['exclusionId'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
        'groupIds': !exists(json, 'groupIds') ? undefined : json['groupIds'],
        'hideDemoClients': !exists(json, 'hideDemoClients') ? undefined : json['hideDemoClients'],
        'hideExcluded': !exists(json, 'hideExcluded') ? undefined : json['hideExcluded'],
        'integrationPlatform': !exists(json, 'integrationPlatform') ? undefined : ControlIntegrationPlatform6FromJSON(json['integrationPlatform']),
        'onlyChatOps': !exists(json, 'onlyChatOps') ? undefined : json['onlyChatOps'],
        'onlyWasContained': !exists(json, 'onlyWasContained') ? undefined : json['onlyWasContained'],
        'onlyWasEscalated': !exists(json, 'onlyWasEscalated') ? undefined : json['onlyWasEscalated'],
        'orderBy': !exists(json, 'orderBy') ? undefined : json['orderBy'],
        'orderDir': !exists(json, 'orderDir') ? undefined : ControlOrderDirFromJSON(json['orderDir']),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'search': !exists(json, 'search') ? undefined : json['search'],
        'severity': !exists(json, 'severity') ? undefined : ControlSeverity8FromJSON(json['severity']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'startDate': !exists(json, 'startDate') ? undefined : json['startDate'],
        'statuses': !exists(json, 'statuses') ? undefined : ((json['statuses'] as Array<any>).map(ControlStatus9FromJSON)),
        'verdict': !exists(json, 'verdict') ? undefined : ControlVerdict9FromJSON(json['verdict']),
    };
}

export function ControlSearchDetectionsDtoToJSON(value?: ControlSearchDetectionsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assetId': value.assetId,
        'assetType': ControlAssetType1ToJSON(value.assetType),
        'caseIdOrSid': value.caseIdOrSid,
        'category': ControlCategory8ToJSON(value.category),
        'categoryClass': ControlCategoryClass2ToJSON(value.categoryClass),
        'createdAt': ControlDateFilterDtoToJSON(value.createdAt),
        'days': value.days,
        'endDate': value.endDate,
        'exclusionId': value.exclusionId,
        'filter': value.filter,
        'groupIds': value.groupIds,
        'hideDemoClients': value.hideDemoClients,
        'hideExcluded': value.hideExcluded,
        'integrationPlatform': ControlIntegrationPlatform6ToJSON(value.integrationPlatform),
        'onlyChatOps': value.onlyChatOps,
        'onlyWasContained': value.onlyWasContained,
        'onlyWasEscalated': value.onlyWasEscalated,
        'orderBy': value.orderBy,
        'orderDir': ControlOrderDirToJSON(value.orderDir),
        'page': value.page,
        'search': value.search,
        'severity': ControlSeverity8ToJSON(value.severity),
        'size': value.size,
        'startDate': value.startDate,
        'statuses': value.statuses === undefined ? undefined : ((value.statuses as Array<any>).map(ControlStatus9ToJSON)),
        'verdict': ControlVerdict9ToJSON(value.verdict),
    };
}

